import {MailActionsType} from "@twigsby/client-data";
import {Button, ColourSolid, ContentLoader, Tooltip} from "@twigsby/frontend-framework";
import React, {memo} from "react";
import { MailActionsIconMap } from "../../Data/MailActionsIconMap";
import {useMailbox} from "../../Providers/NewMailboxProvider";

const MailActionButtons = memo((props: MailActionsType) => {
    const { mailItemActionsStatus, selectionActions } = useMailbox();

    return (
        <>
            {(mailItemActionsStatus=== 'loading') ? (
                <ContentLoader childHeight={'2.9em'} childWidth={'20em'} childCount={1} rounded={true} contentRounded={true} />
            ) : selectionActions && selectionActions.length > 0 ? (
                <>
                    {selectionActions && selectionActions.map((action: any, index: number) => action.name === 'Open and Scan' && !action.disabled ?
                        <Tooltip content={action.name} key={index}>
                            <Button
                                title={action.name}
                                iconOnly={props.iconsOnly}
                                icon={MailActionsIconMap[action.name]}
                                colour={ColourSolid.Success}
                                squared={true}
                                onClick={() => props.actionCallback ? props.actionCallback(action.transitionId) : null}
                            />
                        </Tooltip>
                        : null)}

                    <div className={'btn-group btn-group-row p-0'}>

                        {selectionActions && selectionActions.map((action: any, index: number) => action.name === 'Scan Remaining Pages' && !action.disabled ?
                            <Tooltip content={action.name} key={index}>
                                <Button
                                    title={action.name}
                                    iconOnly={props.iconsOnly}
                                    icon={MailActionsIconMap[action.name]}
                                    colour={ColourSolid.Secondary}
                                    onClick={() => props.actionCallback ? props.actionCallback(action.transitionId) : null}
                                />
                            </Tooltip>
                            : null)}

                        {selectionActions && selectionActions.map((action: any, index: number) => action.name === 'Forward' && !action.disabled ?
                            <Tooltip content={action.name} key={index}>
                                <Button
                                    title={action.name}
                                    iconOnly={props.iconsOnly}
                                    icon={MailActionsIconMap[action.name]}
                                    colour={ColourSolid.Danger}
                                    onClick={() => props.actionCallback ? props.actionCallback(action.transitionId) : null}
                                />
                            </Tooltip>
                            : null)}

                        {selectionActions && selectionActions.map((action: any, index: number) => action.name === 'Physical Store' && !action.disabled ?
                            <Tooltip content={action.name} key={index}>
                                <Button
                                    title={action.name}
                                    iconOnly={props.iconsOnly}
                                    icon={MailActionsIconMap[action.name]}
                                    colour={ColourSolid.Danger}
                                    onClick={() => props.actionCallback ? props.actionCallback(action.transitionId) : null}
                                />
                            </Tooltip>
                            : null)}

                        {selectionActions && selectionActions.map((action: any, index: number) => action.name === 'Digital Store' && !action.disabled ?
                            <Tooltip content={action.name} key={index}>
                                <Button
                                    title={action.name}
                                    iconOnly={props.iconsOnly}
                                    icon={MailActionsIconMap[action.name]}
                                    colour={ColourSolid.Secondary}
                                    onClick={() => props.actionCallback ? props.actionCallback(action.transitionId) : null}
                                />
                            </Tooltip>
                            : null)}
                    </div>

                    {selectionActions && selectionActions.map((action: any, index: number) => action.name === 'Return to Sender' && !action.disabled ?

                        <Tooltip content={action.name} key={index}>
                            <Button
                                title={action.name}
                                icon={MailActionsIconMap[action.name]}
                                iconOnly={props.iconsOnly}
                                colour={ColourSolid.Secondary}
                                squared={true}
                                onClick={() => props.actionCallback ? props.actionCallback(action.transitionId) : null}
                                disabled={action.disabled}
                            />
                        </Tooltip>
                        : null)}

                    <div className={'btn-group btn-group-row p-0'}>
                        {selectionActions && selectionActions.map((action: any, index: number) => action.name === 'Delete' && !action.disabled ?
                            <Tooltip content={action.name} key={index}>
                                <Button
                                    title={action.name}
                                    iconOnly={props.iconsOnly}
                                    icon={MailActionsIconMap[action.name]}
                                    colour={ColourSolid.Alert}
                                    onClick={() => props.actionCallback ? props.actionCallback(action.transitionId) : null}
                                />
                            </Tooltip>
                            : null)}
                        {selectionActions && selectionActions.map((action: any, index: number) => action.name === 'Recycle' && !action.disabled ?
                            <Tooltip content={action.name} key={index}>
                                <Button
                                    title={action.name}
                                    iconOnly={props.iconsOnly}
                                    icon={MailActionsIconMap[action.name]}
                                    colour={ColourSolid.Alert}
                                    onClick={() => props.actionCallback ? props.actionCallback(action.transitionId) : null}
                                />
                            </Tooltip>
                            : null)}
                        {selectionActions && selectionActions.map((action: any, index: number) => action.name === 'Shred' && !action.disabled ?
                            <Tooltip content={action.name} key={index}>
                                <Button
                                    title={action.name}
                                    iconOnly={props.iconsOnly}
                                    icon={MailActionsIconMap[action.name]}
                                    colour={ColourSolid.Alert}
                                    onClick={() => props.actionCallback ? props.actionCallback(action.transitionId) : null}
                                />
                            </Tooltip>
                            : null)}
                    </div>

                    {selectionActions && selectionActions.map((action: any, index: number) => action.name === 'Email' && !action.disabled ?
                        <Tooltip content={action.name} key={index}>
                            <Button
                                title={action.name}
                                iconOnly={true}
                                icon={MailActionsIconMap[action.name]}
                                colour={ColourSolid.Secondary}
                                squared={true}
                                onClick={() => props.actionCallback ? props.actionCallback(action.transitionId) : null}
                            />
                        </Tooltip>
                    : null)}
                </>
            ) : (
                <></>
            )}
        </>
    )
})

export default MailActionButtons
